function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  fill: "#333"
});

function SvgDisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 8",
    fill: "none"
  }, props), _ref);
}

export default SvgDisc;